var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 35.075,
    y1: 129.455,
    x2: 214.925,
    y2: 129.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6679b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbccf8"
  })))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 125,
    cy: 129.455,
    rx: 89.925,
    ry: 88.343,
    style: {
      fill: "url(#linear-gradient)",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72.553,112.822l50.015-38.755c3.161-2.45,7.58-2.45,10.741,0l50.015,38.755v64.948h-110.771v-64.948Z",
    style: {
      fill: "#ffd715"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 85.366,
    y: 78.397,
    width: 85.144,
    height: 93.635,
    style: {
      fill: "#f2f8fd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.492,
    y: 84.034,
    width: 74.893,
    height: 2.855,
    style: {
      fill: "#dcdcdc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.492,
    y: 89.771,
    width: 63.647,
    height: 2.855,
    style: {
      fill: "#dcdcdc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.492,
    y: 95.509,
    width: 53.32,
    height: 2.855,
    style: {
      fill: "#dcdcdc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.492,
    y: 106.525,
    width: 53.32,
    height: 2.855,
    style: {
      fill: "#dcdcdc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.492,
    y: 112.033,
    width: 39.55,
    height: 2.855,
    style: {
      fill: "#dcdcdc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.938,
    y: 123.573,
    width: 39.55,
    height: 2.855,
    style: {
      fill: "#dcdcdc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.32,
    y: 129.195,
    width: 32.168,
    height: 2.855,
    style: {
      fill: "#dcdcdc"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "130.042 145.315 74.656 112.86 74.656 177.77 130.042 145.315",
    style: {
      fill: "#fcbd11"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.042 145.315 185.427 112.86 185.427 177.77 130.042 145.315",
    style: {
      fill: "#fcbd11"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.671,139.015l-50.015,38.755h110.771l-50.015-38.755c-3.161-2.45-7.58-2.45-10.741,0Z",
    style: {
      fill: "#ffcc01"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "33.564 45.772 57.832 107.474 109.542 78.288 33.564 45.772",
    style: {
      fill: "#29aae2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.564 45.772 81.257 94.253 94.244 86.923 33.564 45.772",
    style: {
      fill: "#137fa5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.244 86.923 85.199 109.301 81.257 94.253 94.244 86.923",
    style: {
      fill: "#137fa5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.199 109.301 74.039 98.327 81.257 94.253 85.199 109.301",
    style: {
      fill: "#014759"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteUser);
export default __webpack_public_path__ + "static/media/InviteUser.c66bad9bfde91e4b4f0bf6c642f2fc6b.svg";
export { ForwardRef as ReactComponent };